// Per-county status picker for the admin participation table. A compact MUI
// Select whose closed state shows a colored status dot + label so the column is
// scannable at a glance; the dot mirrors the choropleth fill and is paired with
// text so status never relies on color alone. Selecting a value auto-saves
// (optimistic, handled by the slice) — there is no row-level Save button. The
// control is disabled while its write is in flight.
import { MenuItem, Select, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import {
  PARTICIPATION_STATUS_ORDER,
  PARTICIPATION_STATUS_LABELS,
} from '../../../config/participation.js';

const StatusDot = ({ status }) => {
  const theme = useTheme();
  return (
    <Box
      component="span"
      aria-hidden="true"
      sx={{
        width: 12,
        height: 12,
        flexShrink: 0,
        borderRadius: '50%',
        bgcolor: theme.participationColors[status],
        border: `1px solid ${theme.mapColors.landStroke}`,
      }}
    />
  );
};

const ParticipationStatusSelect = ({
  countyId, countyName, status, saving, onChange,
}) => (
  <Select
    size="small"
    value={status}
    disabled={saving}
    onChange={(e) => onChange(countyId, e.target.value)}
    inputProps={{ 'aria-label': `Status for ${countyName}` }}
    renderValue={(value) => (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <StatusDot status={value} />
        {PARTICIPATION_STATUS_LABELS[value]}
      </Box>
    )}
    sx={{ minWidth: 230 }}
  >
    {PARTICIPATION_STATUS_ORDER.map((s) => (
      <MenuItem key={s} value={s}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <StatusDot status={s} />
          {PARTICIPATION_STATUS_LABELS[s]}
        </Box>
      </MenuItem>
    ))}
  </Select>
);

export default ParticipationStatusSelect;
